import template from './self_review_rating_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class SelfReviewRatingHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.selected_tab = ko.observable('singleselect');

		this.selected_tab.subscribe((newCategory) => {
			$('.rating-methods > li').removeClass('active');
			$(`.rating-methods > li[data-tabname=${newCategory}]`).addClass('active');
		});

		$(`.rating-methods > li[data-tabname=${this.selected_tab()}]`).addClass('active');
	};

	switch_tabs(v, e)
	{
		let tabname = e.currentTarget.getAttribute('data-tabname');
		this.selected_tab(tabname);
	}

	close()
	{
		this.dialog.close();
	}
};

class SelfReviewRatingHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new SelfReviewRatingHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'SelfReviewRatingHelp',
	dialog_class: SelfReviewRatingHelpPage,
	template: template,
	template_filename: 'translation/dialogs/self_review_rating_help',
	provider: 'ps'
};